import { Component } from '@angular/core';
import { soundpostCompanySequenceEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Company Sequences') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostcompanysequence-form',
    templateUrl: './soundpostcompanysequence.form.component.html'
})
export class soundpostCompanySequenceFormComponent extends BaseFormComponent {
    public record!: soundpostCompanySequenceEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

